export const posters = [
  {
    text: "Fit Log",
    imagePath: "fitlog.mp4",
    description: "Fitness tracking & workout planning app",
    websiteLink: "https://fitlogai.co.uk",
    websiteLabel: "fitlogai.co.uk",
    status: "Cooking! 🧑‍🍳",
    fancyTech: ["Agentic AI", "Blockchain", "3D"],
  },
  {
    text: "Pezego",
    imagePath: "pezego.png",
    description: "Aadvanced pest management and agricultural field supervision.",
    androidLink:
      "https://play.google.com/store/apps/details?id=uk.ac.farmguardian&hl=en",
    iosLink: "https://apps.apple.com/us/app/pezego/id6739448984",
  },
  {
    text: "Parallel Farm",
    imagePath: "parallel_farm.png",
    description: "Smart agriculture management system",
    androidLink:
      "https://play.google.com/store/apps/details?id=uk.ac.shef.oak.com6510&hl=en_GB",
    iosLink: "https://apps.apple.com/gb/app/parallel-farm/id6739890616",
  },
  {
    text: "Bus",
    imagePath: "bus.png",
    description: "Bus booking & tracking platform",
    status: "Live in 15+ bank apps",
  },
  {
    text: "Flight",
    imagePath: "flight.png",
    description: "Flight booking & management system",
    status: "Live in 15+ bank apps",
  },
  {
    text: "Recharge",
    imagePath: "recharge.png",
    description: "Mobile recharge & bill payments",
    status: "Live in 15+ bank apps",
  },
  {
    text: "Hotel",
    imagePath: "hotel.png",
    description: "Hotel booking & reservation system",
    status: "Live in 15+ bank apps",
  },
  {
    text: "Event",
    imagePath: "event.png",
    description: "Event management & ticketing platform",
    status: "Live in 15+ bank apps",
  },
  {
    text: "Gift Card",
    imagePath: "gift_card.png",
    description: "Digital gift card solution",
    status: "Live in 15+ bank apps",
  },
  {
    text: "Pest Shield",
    imagePath: "pest_sheild.png",
    description: "Pest control management system",
    status: "Dissertation Project",
    fancyTech: ["LLM", "Object Detection", "Blockchain"],
  },
]; 
